export function setLocalStorageItem(key: string, value: string): void {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        /* do nothing */
    }
}
